export default "__VITE_ASSET__zv$Iont___"